import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 24
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSecs = prev.seconds - 1;
        let newMins = prev.minutes;
        let newHours = prev.hours;
        if (newSecs < 0) {
          newSecs = 59;
          newMins -= 1;
        }
        if (newMins < 0) {
          newMins = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMins,
          seconds: newSecs
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy py-12 px-6 border-t border-white/10 relative overflow-hidden" data-id="element-89">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-90">
        <div className="text-center mb-8" data-id="element-91">
          <h3 className="text-gold font-bold text-xl mb-2 uppercase tracking-wider" data-id="element-92">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="flex justify-center gap-3 text-3xl md:text-4xl font-display font-bold text-danger mb-8" data-id="element-93">
            <span data-id="element-94">{format(timeLeft.hours)}</span>:
            <span data-id="element-95">{format(timeLeft.minutes)}</span>:
            <span data-id="element-96">{format(timeLeft.seconds)}</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-97">
          {/* Compact Option 1 */}
          <div className="bg-white rounded-2xl p-5 text-center border border-gray-200" data-id="element-98">
            <span className="text-sm font-bold text-secondary mb-1 block" data-id="element-99">
              ⬜ OPCIÓN 1
            </span>
            <h4 className="font-display text-xl font-bold text-primary mb-1" data-id="element-100">
              📘 MEGAPACK 1
            </h4>
            <p className="text-sm text-secondary mb-3" data-id="element-101">
              5 Tomos + 3 Bonos · Empezar desde hoy
            </p>
            <div className="mb-4" data-id="element-102">
              <span className="text-gray-400 line-through text-lg mr-2" data-id="element-103">
                75,76€
              </span>
              <span className="text-3xl font-extrabold text-primary" data-id="element-104">
                14,97€
              </span>
            </div>
            <button onClick={scrollToPricing} className="w-full bg-gray-900 text-white font-bold py-2.5 rounded-xl hover:bg-gray-800 transition-colors" data-id="element-105">
              → QUIERO MI MEGAPACK
            </button>
          </div>

          {/* Compact Option 2 */}
          <div className="bg-gold/10 rounded-2xl p-5 text-center border-2 border-gold relative" data-id="element-106">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-navy text-xs font-bold px-3 py-1 rounded-full" data-id="element-107">
              ⭐ MÁS ELEGIDO
            </div>
            <span className="text-sm font-bold text-gold mb-1 block mt-1" data-id="element-108">
              🔘 OPCIÓN 2
            </span>
            <h4 className="font-display text-xl font-bold text-white mb-1" data-id="element-109">
              🏆 MEGAPACK COMPLETO
            </h4>
            <p className="text-sm text-gray-300 mb-3" data-id="element-110">
              10 Tomos + 7 Bonos · Sistema Completo
            </p>
            <div className="mb-4" data-id="element-111">
              <span className="text-gray-400 line-through text-lg mr-2" data-id="element-112">
                157,49€
              </span>
              <span className="text-3xl font-extrabold text-gold" data-id="element-113">23,97€</span>
            </div>
            <button onClick={scrollToPricing} className="w-full bg-gold text-navy font-extrabold py-2.5 rounded-xl hover:bg-gold-light transition-colors shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-114">
              → QUIERO EL SISTEMA COMPLETO
            </button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400 font-medium" data-id="element-115">
          <span className="flex items-center gap-2" data-id="element-116">
            <Lock className="w-4 h-4" data-id="element-117" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-118">
            <Zap className="w-4 h-4" data-id="element-119" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-120">
            <ShieldCheck className="w-4 h-4" data-id="element-121" /> Garantía 7 días
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full overflow-hidden pointer-events-none opacity-10" data-id="element-122">
        <div className="absolute bottom-[-50%] left-1/2 -translate-x-1/2 w-[100%] h-[100%] rounded-full bg-gold blur-[150px]" data-id="element-123"></div>
      </div>
    </section>;
}